"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouteConfirm = void 0;
const react_1 = require("react");
const router_1 = require("../router");
const useRouteConfirm = ({ showConfirm, render }) => {
    const { block, goTo, replace, resolveRoute, unblock } = (0, router_1.useRouterActions)();
    const [isActive, setActive] = (0, react_1.useState)(false);
    const [action, setAction] = (0, react_1.useState)(null);
    const [nextPathname, setNextPathname] = (0, react_1.useState)(null);
    const handleCancel = (0, react_1.useCallback)(() => {
        setActive(false);
        setNextPathname(null);
    }, []);
    const handleConfirm = (0, react_1.useCallback)(() => {
        unblock();
        const { name, params, query } = resolveRoute(nextPathname || '');
        if (action === 'REPLACE') {
            replace(name, params, query);
            return;
        }
        goTo(name, params, query);
    }, [action, nextPathname]);
    (0, react_1.useEffect)(() => {
        block(({ pathname, hash }, action) => {
            if (showConfirm) {
                setActive(true);
                setAction(action);
                setNextPathname(hash || pathname);
                return false;
            }
            return;
        });
        return () => {
            unblock();
        };
    }, [showConfirm]);
    return render({ isActive, cancel: handleCancel, confirm: handleConfirm });
};
exports.useRouteConfirm = useRouteConfirm;
//# sourceMappingURL=useRouteConfirm.js.map